import { io, type Socket } from "socket.io-client";
import { useEffect } from "react";

// One Socket.IO connection per tab; the server authenticates it with the access cookie. The client room follows the
// selected client so events never leak across tenants.

let socket: Socket | null = null;
let joinedClient: string | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io({ path: "/socket.io", withCredentials: true, transports: ["websocket", "polling"], autoConnect: true });
    socket.on("connect", () => {
      if (joinedClient) socket?.emit("client:join", joinedClient);
    });
  }
  return socket;
}

export function joinClientRoom(clientId: string | null): void {
  joinedClient = clientId;
  const s = getSocket();
  if (clientId && s.connected) s.emit("client:join", clientId);
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
  joinedClient = null;
}

/** Subscribes to a realtime event for the lifetime of the component. */
export function useRealtime<T = unknown>(event: string, handler: (data: T) => void, enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    const s = getSocket();
    const fn = (data: T) => handler(data);
    s.on(event, fn);
    return () => {
      s.off(event, fn);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, enabled]);
}
